const insuranceTranslate: Record<string, string> = {
  'STATUS.INSURANCE.PAID': 'Pagado',
  'STATUS.INSURANCE.PENDING': 'Pendiente',
}

export default insuranceTranslate
